import { VerifiedBadge } from "../components/VerifiedBadge";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Navbar";
import { Avatar } from "../components/Posts";
import { formatProName } from "../lib/proName";
import { api } from "../api";

export default function Professionals() {
  const { t, i18n } = useTranslation();
  const [pros, setPros] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/professionals", { params: { q } }).then(({data}) => setPros(data)); }, [q]);
  return (<Layout><div className="yp-container py-8">
    <h1 className="text-3xl font-bold mb-4">{t("nav.professionals")}</h1>
    <input className="yp-input mb-6 max-w-md" placeholder={t("common.search")} value={q} onChange={e=>setQ(e.target.value)} data-testid="pro-search" />
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
      {pros.length === 0 && <div className="col-span-full text-center text-slate-400 py-12" data-testid="professionals-empty">{t("common.empty")}</div>}
      {pros.map(p => (
        <Link key={p.id} to={`/professionals/${p.id}`} className="yp-card p-5 block" data-testid="doctor-card-profile-btn">
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center gap-2">
              <Avatar url={p.avatar_url} label={p.first_name} cls="w-10 h-10" />
              <div><div className="font-semibold flex items-center gap-1">{formatProName({ title: p.professional_title, first_name: p.first_name, last_name: p.last_name }, i18n.language)}{p.verified && <VerifiedBadge size={15} />}</div>
              <div className="text-xs text-slate-500">{p.profession} · {p.specialization}</div></div>
            </div>
          </div>
          <div className="text-sm text-slate-600 mt-2">📍 {p.country}</div>
        </Link>))}
    </div>
  </div></Layout>);
}
